import React from 'react'

const UploadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.17222 11.4444H17.1722V12.6944H7.17222V11.4444ZM7.17222 16.4444H12.1722V15.1944H7.17222V16.4444ZM20.125 7.78889V21.4C20.1243 21.5589 20.0608 21.7111 19.9485 21.8235C19.8361 21.9358 19.6839 21.9993 19.525 22H4.475C4.31562 21.9993 4.16301 21.9354 4.05057 21.8225C3.93812 21.7095 3.875 21.5566 3.875 21.3972V2.60278C3.875 2.44339 3.93812 2.29049 4.05057 2.17753C4.16301 2.06457 4.31562 2.00073 4.475 2H14.375C14.4537 2.00008 14.5315 2.01584 14.604 2.04637C14.6765 2.07689 14.7422 2.12157 14.7972 2.17778L19.95 7.36111C20.0621 7.4753 20.1249 7.62889 20.125 7.78889ZM14.9722 7.18333H18.0806L14.9722 4.05833V7.18333ZM18.9278 20.7944V8.38889H13.775V3.20556H5.07222V20.7944H18.9278Z"
        fill="#AAAAAA"
      />
    </svg>
  )
}

export default UploadIcon
